import DefaultRceSettingsPresenter from './presenter';
import { connect, getActiveQuiz, setQuizDefaultRceSettings } from '@instructure/quiz-core';
export function mapStateToProps(state) {
  var _activeQuiz$getWorkin;
  var activeQuiz = getActiveQuiz(state);
  return {
    defaultRceSettings: (_activeQuiz$getWorkin = activeQuiz.getWorkingInstance().defaultRceSettings) === null || _activeQuiz$getWorkin === void 0 ? void 0 : _activeQuiz$getWorkin.toJS(),
    activeQuizId: activeQuiz.id
  };
}
export var DefaultRceSettings = connect(mapStateToProps, {
  setQuizDefaultRceSettings: setQuizDefaultRceSettings
})(DefaultRceSettingsPresenter);
export default DefaultRceSettings;